/* global getComputedStyle */

export default (rem) => (
  typeof getComputedStyle !== 'undefined'
    ? rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    : rem * 10
)
